// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jhIWP","sliderWrapper":"styles_sliderWrapper__cljVx","slider":"styles_slider__HgQsB","img":"styles_img__c_SmL","slide":"styles_slide__9i_EM"};